import {
  ON_GEL_UPDATE,
  ON_GEL_SELECT,
  ON_SUBMIT,
  ON_RESET,
  CLOSE_FEEDBACK
} from '../../Redux.constants';
import {
  onGelUpdate,
  onGelSelect,
  onCloseFeedback,
  onGelSubmit,
  onGelReset
} from './helper';

export function GelDragDropQuestionReducer(state, action) {

  switch (action.type) {
    case ON_SUBMIT:
      return onGelSubmit(state, action.payload);
    case ON_RESET:
      return onGelReset(state, action.payload);
    case CLOSE_FEEDBACK:
      return onCloseFeedback(state, action.payload);
    case ON_GEL_UPDATE:
      return onGelUpdate(state, action.payload);
    case ON_GEL_SELECT:
      return onGelSelect(state, action.payload);
    default:
      return state;
  }
}
